export class Post {
    name: string;
    description: string;
    key?: string;

    constructor(values: any) {
        this.name = values.name;
        this.description = values.description;
        if (values.key) { this.key = values.key }
    }
}



// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/class/post.ts